<template>
  <div class="db-totals">
    <div class="db-totals-header">
      <h2 class="db-totals-title">In the system</h2>
      <v-btn
        icon
        small
        class="db-totals-refresh"
        :dark="$vuetify.dark"
        :loading="loading"
        :disabled="loading"
        aria-label="Refresh counts"
        @click="loadStats"
      >
        <v-icon small>refresh</v-icon>
      </v-btn>
    </div>
    <v-layout row wrap class="db-totals-row">
      <v-flex xs12 sm4 class="db-totals-col">
        <v-card class="db-totals-card" flat :dark="$vuetify.dark">
          <v-card-text class="text-xs-center pa-3">
            <v-icon color="red darken-2" size="36" class="mb-2"
              >business</v-icon
            >
            <div class="db-totals-label">Schools / clubs</div>
            <div v-if="loading" class="db-totals-value">
              <v-progress-circular indeterminate size="28" width="2" />
            </div>
            <div v-else class="db-totals-value">{{ formatCount(schools) }}</div>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 sm4 class="db-totals-col">
        <v-card class="db-totals-card" flat :dark="$vuetify.dark">
          <v-card-text class="text-xs-center pa-3">
            <v-icon color="red darken-2" size="36" class="mb-2">person</v-icon>
            <div class="db-totals-label">Wrestlers</div>
            <div v-if="loading" class="db-totals-value">
              <v-progress-circular indeterminate size="28" width="2" />
            </div>
            <div v-else class="db-totals-value">
              {{ formatCount(athletes) }}
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 sm4 class="db-totals-col">
        <v-card class="db-totals-card" flat :dark="$vuetify.dark">
          <v-card-text class="text-xs-center pa-3">
            <v-icon color="red darken-2" size="36" class="mb-2"
              >sports_kabaddi</v-icon
            >
            <div class="db-totals-label">Matches</div>
            <div v-if="loading" class="db-totals-value">
              <v-progress-circular indeterminate size="28" width="2" />
            </div>
            <div v-else class="db-totals-value">
              {{ formatCount(matchDocs) }}
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import {
  getFirestore,
  collection,
  getCountFromServer,
} from "firebase/firestore";
import { MATCHES_CANONICAL_COLLECTION } from "../utils/canonicalMatches";

export default {
  name: "DatabaseTotalsCards",
  data() {
    return {
      loading: false,
      schools: null,
      athletes: null,
      matchDocs: null,
    };
  },
  mounted() {
    this.loadStats();
  },
  methods: {
    formatCount(n) {
      if (n == null || !Number.isFinite(n)) return "—";
      return n.toLocaleString();
    },
    async loadStats() {
      this.loading = true;
      try {
        const db = getFirestore();
        const [schoolAgg, athleteAgg, matchAgg] = await Promise.all([
          getCountFromServer(collection(db, "schools")),
          getCountFromServer(collection(db, "athletes")),
          getCountFromServer(collection(db, MATCHES_CANONICAL_COLLECTION)),
        ]);
        this.schools = schoolAgg.data().count;
        this.athletes = athleteAgg.data().count;
        this.matchDocs = matchAgg.data().count;
      } catch (_e) {
        this.schools = null;
        this.athletes = null;
        this.matchDocs = null;
        this.$root.$emit(
          "toast",
          "Could not load database totals (check connection or permissions).",
          "error"
        );
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.db-totals {
  margin-top: 1.5rem;
  padding-top: 1.25rem;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
}

.theme--dark .db-totals {
  border-top-color: rgba(255, 255, 255, 0.12);
}

.db-totals-header {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 12px;
}

.db-totals-title {
  font-size: 1.125rem;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.87);
  margin: 0;
}

.theme--dark .db-totals-title {
  color: rgba(255, 255, 255, 0.95);
}

.db-totals-refresh {
  margin: 0 !important;
}

.db-totals-row {
  margin: 0 -4px;
}

.db-totals-col {
  padding: 4px;
}

.db-totals-card {
  border-radius: 10px;
  height: 100%;
  min-height: 132px;
  border: 1px solid rgba(0, 0, 0, 0.08) !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06) !important;
}

.theme--dark .db-totals-card {
  border-color: rgba(255, 255, 255, 0.12) !important;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.45) !important;
}

.db-totals-label {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: rgba(0, 0, 0, 0.54);
  margin-bottom: 8px;
}

.theme--dark .db-totals-label {
  color: rgba(255, 255, 255, 0.6);
}

.db-totals-value {
  font-size: 1.65rem;
  font-weight: 700;
  color: #b71c1c;
  line-height: 1.2;
  min-height: 2.1rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.theme--dark .db-totals-value {
  color: #ef5350;
}

.db-totals-sub {
  margin-top: 6px;
  line-height: 1.3;
  color: rgba(0, 0, 0, 0.54);
}

.theme--dark .db-totals-sub {
  color: rgba(255, 255, 255, 0.55);
}
</style>
